<template>
  <div class="content-warpper">
    <div class="warpper-title flex align-center justify-between">
      <div>
        <i class="iconfont iconjigou2"></i>
        实习基地详情
      </div>


    </div>
    <div class="padding-sm flex align-start justify-between detail-warpper" v-if="orgDetail">
      <div class="flex-sub info-warpper">

        <h2 class="flex align-center detail-title margin-bottom-xs"><span>实习基地详情</span></h2>
        <el-row class="org-info">
          <el-col :span="4"><div class="label-box">机构名称</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.org_name }}</div></el-col>
          <el-col :span="4"><div class="label-box">授权编号</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.org_num }} </div></el-col>
          <el-col :span="4"><div class="label-box">机构组织代码</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.org_code }} </div></el-col>
          <el-col :span="4"><div class="label-box">机构所在地</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.regionArr }}{{orgDetail.address}}</div></el-col>
          <el-col :span="4"><div class="label-box">联系人姓名</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.username }}</div></el-col>
          <el-col :span="4"><div class="label-box">联系人手机号</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.phone }}</div></el-col>
          <el-col :span="4"><div class="label-box">联系人邮箱</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.email }}</div></el-col>
          <el-col :span="4"><div class="label-box">到期时间</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.due_date }}</div></el-col>
          <el-col :span="4"><div class="label-box">隶属协调中心</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.xtzx_id }}</div></el-col>
          <el-col :span="4"><div class="label-box"> </div></el-col>
          <el-col :span="8"><div class="info-box"> </div></el-col>
        </el-row>

        <div class="flex align-start margin-tb">
          <h3 class="margin-right">营业执照</h3>
          <el-image
              style="width: 200px; height: 150px"
              :src="imgUrl + orgDetail.org_license"
              :preview-src-list="[imgUrl + orgDetail.org_license]">
          </el-image>
        </div>
        <div class="flex align-start margin-tb" v-if="orgDetail.longitude">
          <h3 class="margin-right">地理位置</h3>
          <div class="flex-sub">
            <div id="map-container" style="width:100%;height:300px;"/>


          </div>
        </div>
        <div class="quest-item">
          <p class="quest-title">到达您机构位置的公共交通方式及路线，包括公交、地铁线路，具体哪路公交车，哪条地铁，在哪一站出站</p>
          <div class="anwer-info">{{ orgDetail.way }}</div>
        </div>

        <div>
          <h3 class="detail-small-title">二、申请单位本身或附近住宿和餐饮情况</h3>
          <div class="quest-item">
            <p class="quest-title">贵机构对实习生食宿的解决方案   附近是否有协议民俗或宿舍，是否有食堂，平均月房租价格范围等信息</p>
            <div class="anwer-info">{{ orgDetail.huanjing }}</div>
          </div>
          <div class="quest-item">
            <p class="quest-title">其他附加材料及文档</p>
            <div class="anwer-info"> <el-link type="primary" :href="fileUrl + orgDetail.huanjing_file" target="_blank">附件:{{orgDetail.huanjing_file}}（点击下载）</el-link></div>
          </div>
        </div>
        <div>
          <h3 class="detail-small-title">三、 申请单位实习情况说明</h3>
          <div class="quest-item">
            <p class="quest-title">申请单位是否有接收实习生经历，如有请简单介绍情况（请用附件说明）</p>
<!--            <div class="anwer-info">{{ orgDetail.shixi_desc }}</div>-->
            <div class="anwer-info"> <el-link type="primary" :href="fileUrl + orgDetail.shixi_desc" target="_blank">附件:{{orgDetail.shixi_desc}}（点击下载）</el-link></div>
          </div>
        </div>
        <div>
          <h3 class="detail-small-title">四、申请单位年度实习岗位计划和实习导师配备计划</h3>

          <div class="quest-item flex align-center">
            <p class="quest-title" style="width: 180px;">年度申请实习岗位总数量</p>
            <div class="anwer-info flex-sub">{{ orgDetail.jihua_num }}</div>
          </div>
          <div class="quest-item flex align-center">
            <p class="quest-title" style="width: 180px;">期望接收实习人员月份</p>
            <div class="anwer-info flex-sub">{{ orgDetail.month }}</div>
          </div>
          <div class="quest-item">
            <p class="quest-title">实习导师配备计划   请说明实习导师与实习人员的配比比例，以及实习导师数量，例如：实习导师6人，导师:实习比例为1:5</p>
            <div class="anwer-info">{{ orgDetail.shizi }}</div>
          </div>
          <div class="quest-item">
            <p class="quest-title">可提供实习岗位类别</p>
            <div class="anwer-info">{{ orgDetail.gangwei }}</div>
          </div>
        </div>
        <div v-if="orgDetail.remark">
          <h3 class="detail-small-title">五、其他信息</h3>
          <div class="quest-item">
            <p class="quest-title">备注信息</p>
            <div class="anwer-info">{{ orgDetail.remark }}</div>
          </div>
        </div>
        <!--        正常的审核-->
        <div class="margin-tb flex align-center justify-around" v-if="isExamine">
          <examine :id="orgDetail.id" :region="orgDetail.region_text"  :orgType="3"/>
        </div>
        <!--        年审的审核-->
        <div class="margin-tb flex align-center justify-around" v-if="isYearExamine">
          <el-button type="success" class="examine-btn">通过</el-button>
          <el-button type="danger" class="examine-btn">拒绝</el-button>
        </div>
      </div>
      <time-list :id="orgDetail.org_id" :type="3"/>


    </div>
  </div>
</template>
<script>
import loadBMap from "@/tools/utils";
import {shenheDetail} from "@/api/projectOffice";
import {CodeToText} from "element-china-area-data";
import {FILEURL, IMGURL} from "@/config";
import timeList from "@/views/projectOffice/page/conponents/timeList";
import examine from "@/views/projectOffice/page/conponents/examine";
export default {
  name: "organizationDetail3",
  data() {
    return {
      id: '',
      year:2021,
      yearOptions:[
        {label:'2021年',value:2021},
        {label:'2022年',value:2022},
        {label:'2023年',value:2023},
        {label:'2024年',value:2024}
      ],
      orgDetail:null,
      isExamine:false,
      isYearExamine:false
    }
  },
  computed:{
    imgUrl() {
      return IMGURL
    },
    fileUrl(){
      return FILEURL
    }
  },
  components:{
    timeList,
    examine
  },
  created() {
    this.id = this.$route.query.id
    if(Number(this.$route.query.shenType) === 0 ||Number(this.$route.query.shenType) === 1) this.isExamine = true
    this.$emit(
        "setIndex",
        '/projectOffice/regulators',
        "当前位置：机构管理 > <span>实习基地详情</span> ",
        true
    );
    this.getDetail();
  },
  async mounted() {
    await loadBMap("McBWgFElxpnhhnO5kHHthQyG2KRsHLZS"); //加载引入BMap
  },
  methods: {
    async getDetail(){
      let _data = await shenheDetail(this.id)
      let _arr = _data.data.region_text.split(',')
      _data.data.regionArr = CodeToText[_arr[0]] +  CodeToText[_arr[1]] +  CodeToText[_arr[2]]
      _data.data.latitude = Number(_data.data.latitude)
      _data.data.longitude = Number(_data.data.longitude)
      this.orgDetail = _data.data
      if(this.orgDetail.longitude){
        this.$nextTick(()=>{
          this.initMap();
        })
      }
    },
    //  地图部分
    initMap() {
      var that = this;
      // 1、挂载地图
      this.map = new BMap.Map("map-container", {enableMapClick: false});
      var point = new BMap.Point(this.orgDetail.longitude,this.orgDetail.latitude);
      this.map.centerAndZoom(point, 16);
      // this.map.enableScrollWheelZoom(true);

      // 3、设置图像标注并绑定拖拽标注结束后事件
      this.mk = new BMap.Marker(point, {enableDragging: true});
      this.map.addOverlay(this.mk);
      // this.mk.addEventListener("dragend", function (e) {
      //   that.getAddrByPoint(e.point);
      // });
      // 4、添加（右上角）平移缩放控件
      this.map.addControl(
          new BMap.NavigationControl({
            anchor: BMAP_ANCHOR_TOP_RIGHT,
            type: BMAP_NAVIGATION_CONTROL_SMALL
          })
      );
      // 5、添加（左下角）定位控件
      var geolocationControl = new BMap.GeolocationControl({
        anchor: BMAP_ANCHOR_BOTTOM_LEFT
      });
      geolocationControl.addEventListener("locationSuccess", function (e) {
        that.getAddrByPoint(e.point);
      });
      geolocationControl.addEventListener("locationError", function (e) {
        alert(e.message);
      });
      this.map.addControl(geolocationControl);
      // 6、浏览器定位
      // this.geolocation()
      // 7、绑定点击地图任意点事件
      // this.map.addEventListener('click', function (e) {
      //   that.getAddrByPoint(e.point)
      // })
    }
  }
}
</script>

<style scoped lang="scss">
.detail-warpper{
  .info-warpper{
    .detail-title{
      height: 60px;
      span{
        display: block;
        line-height: 29px;
        font-size:  22px;
        padding-left: 15px;
        position: relative;
        &:before{
          position: absolute;
          left: 0;
          top: 0;
          content: '';
          width: 8px;
          height: 29px;
          background-color: #009688;
          border-radius: 4px;
        }
      }
    }

    .detail-num{
      width: 160px;
      padding: 10px;
      background-color: #ffffff;
      border: solid 1px #dae6f1;
      font-size: 18px;

      span{
        display: block;
        margin-bottom: 10px;
      }
      b{
        font-size: 18px;
        i{
          color: #009688;

        }
      }
      .link-text{
        margin-left: 10px;
        color: #009688;
        font-size: 18px;
      }
    }



    .org-info{
      .label-box{
        display: flex;
        align-items: center;
        height: 48px;
        padding-left: 20px;
        background: #eef7ff;
        border: solid 1px #dae6f1;
      }
      .info-box{
        display: flex;
        align-items: center;
        height: 48px;
        padding-left: 20px;
        background: #fff;
        border: solid 1px #dae6f1;
      }
    }
    .detail-small-title{
      line-height: 30px;
      font-size: 18px;
    }
    .quest-item{
      margin: 10px 0 20px;
      padding-left: 32px;
      .quest-title{
        margin-bottom: 10px;
      }
      .anwer-info{
        width: 100%;
        padding: 15px;
        background-color: #f1f1f1;
        border-radius: 4px;
      }
    }
  }
  .time-list{

    margin-left: 30px;
    width: 340px;
    padding: 30px;
    background-color: #ffffff;
    border: solid 1px #dae6f1;
    p{
      width: 90px;
      height: 20px;
      margin: 0 auto 30px;
      font-size: 18px;
      font-weight: bold;
      line-height: 30px;
      position: relative;
      text-align: center;
      &:before{
        position: absolute;
        left: -20px;
        top: 14px;
        content: '';
        width: 20px;
        height: 2px;
        background-color: #009688;
      }
      &:after{
        position: absolute;
        right: -20px;
        top: 14px;
        content: '';
        width: 20px;
        height: 2px;
        background-color: #009688;
      }
    }
  }

}

</style>